// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"561a5237","688":"67f3aa5c"}[chunkId] + ".chunk.js";
};